package com.macrofocus.eflux.ui.perspective.layers

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.eflux.ui.FieldControl
import mui.material.FormControlLabel
import mui.material.Switch
import org.mkui.react.useProperty
import react.FC
import react.Props
import react.ReactNode
import react.create
import react.dom.events.ChangeEvent
import web.html.HTMLInputElement

external interface LayerSwitchProps : Props {
    var label: String
    var property: MutableProperty<Boolean>
}

val LayerSwitch = FC<LayerSwitchProps> { props ->
    val (getValue, setValue) = useProperty(props.property)

    FieldControl {
        FormControlLabel {
            control = Switch.create() {
                checked = getValue
                onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                    setValue(!props.property.value)
                }
            }
            label = ReactNode(props.label)
        }
    }
}
